import { render, staticRenderFns } from "./LastUpdatedTimestamp.vue?vue&type=template&id=ce741002&"
import script from "./LastUpdatedTimestamp.vue?vue&type=script&lang=js&"
export * from "./LastUpdatedTimestamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/workspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VProgressCircular})
